import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { getMessaging, provideMessaging } from "@angular/fire/messaging";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { TranslateModule } from "@ngx-translate/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { CookieService } from "ngx-cookie-service";
import { ChartComponent } from "./components/chart/chart.component";
import { ConfirmationDialogComponent } from "./components/dialogs/confirmation/confirmation.component";
import { EmojiButtonComponent } from "./components/emoji/emoji.component";
import { EmptyComponent } from "./components/empty/empty.component";
// import { FormComponent } from "./components/form/form.component";
import { LoaderButtonComponent } from "./components/loader-button/loader-button.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { BottomComponent } from "./components/navbar/bottom/bottom.component";
import { TopComponent } from "./components/navbar/top/top.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { NotificationComponent } from "./components/notification/notification.component";
import { PrivacyComponent } from "./components/privacy/privacy.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { StatusComponent } from "./components/status/status.component";
import { FcmService } from "./services/fcm.service";
import { NotificationService } from "./services/notification.service";
import { SettingService } from "./services/setting.service";
// import { TaskCardComponent } from "./components/task-card/task-card.component";
@NgModule({
  declarations: [
    LoaderComponent,
    ChartComponent,
    PrivacyComponent,
    // FormComponent,
    SidebarComponent,
    TopComponent,
    BottomComponent,
    NotFoundComponent,
    ConfirmationDialogComponent,
    LoaderButtonComponent,
    StatusComponent,
    EmojiButtonComponent,
    EmptyComponent,
    // TaskCardComponent,
    NotificationComponent,
  ],
  imports: [
    CommonModule,
    NgxChartsModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    RouterModule,
    MatDialogModule,
    TranslateModule,
    MatTooltipModule,
    PickerModule,
    provideMessaging(() => getMessaging()),
  ],
  exports: [
    NgxChartsModule,
    LoaderComponent,
    ChartComponent,
    PrivacyComponent,
    // FormComponent,
    SidebarComponent,
    TopComponent,
    BottomComponent,
    NotFoundComponent,
    ConfirmationDialogComponent,
    LoaderButtonComponent,
    StatusComponent,
    EmojiButtonComponent,
    EmptyComponent,
    // TaskCardComponent,
    NotificationComponent,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        FcmService,
        NotificationService,
        SettingService,
        CookieService,
      ],
    };
  }
}
